export enum AgencyQueryKeys {
  GET_AGENCY_INFO = 'GET_AGENCY_INFO',
}
